import * as React from "react";

export default function useJsonLd(schema) {
  return React.useEffect(() => {
    if (!schema) {
      return;
    }

    // Remove SSR-injected JSON-LD scripts whose @type matches this schema,
    // so client-managed schemas replace them without removing unrelated SSR schemas
    const schemaType = schema["@type"];
    if (schemaType) {
      document
        .querySelectorAll('script[type="application/ld+json"][data-ssr]')
        .forEach((el) => {
          try {
            const data = JSON.parse(el.textContent);
            if (data["@type"] === schemaType) el.remove();
          } catch {
            // malformed SSR script — remove it
            el.remove();
          }
        });
    }

    const element = document.createElement("script");

    element.setAttribute("type", "application/ld+json");
    element.textContent = JSON.stringify(schema);

    document.head.appendChild(element);

    return () => {
      element.remove();
    };
  }, [schema]);
}
